import { Link } from 'react-router'
import { RiArrowRightLine, RiHome4Line } from 'react-icons/ri'
import { ROUTES } from '@/constants/routes'

export const NotFoundPage = () => (
  <section className="relative min-h-screen bg-base-50 flex items-center justify-center overflow-hidden">
    {/* Decorative circles */}
    <div
      aria-hidden="true"
      className="absolute top-0 right-0 w-96 h-96 rounded-full bg-crimson-50 opacity-60 -translate-y-1/3 translate-x-1/3 pointer-events-none"
    />
    <div
      aria-hidden="true"
      className="absolute bottom-0 left-0 w-72 h-72 rounded-full bg-gold-50 opacity-50 translate-y-1/3 -translate-x-1/3 pointer-events-none"
    />

    {/* Faint 404 watermark */}
    <div
      aria-hidden="true"
      className="absolute inset-0 flex items-center justify-center pointer-events-none select-none"
    >
      <span
        className="font-display font-bold text-base-900 opacity-[0.04] leading-none"
        style={{ fontSize: 'clamp(12rem, 35vw, 32rem)', letterSpacing: '-0.04em' }}
      >
        404
      </span>
    </div>

    {/* Content */}
    <div className="relative z-10 text-center max-w-lg mx-auto px-6 space-y-6 animate-fade-in-up">
      {/* Eyebrow */}
      <p className="text-crimson-600 text-[10.5px] font-bold uppercase tracking-[0.24em]">
        Page Not Found
      </p>

      {/* Heading */}
      <h1
        className="font-display font-bold text-base-900 leading-tight"
        style={{ fontSize: 'clamp(2rem, 5vw, 3.5rem)' }}
      >
        This page doesn't <em className="text-crimson-600 not-italic italic">exist yet</em>
      </h1>

      {/* Divider */}
      <div className="w-12 h-[3px] rounded-full bg-gradient-to-r from-crimson-600 to-gold-500 mx-auto" />

      {/* Message */}
      <p className="text-base-600 text-[15px] leading-[1.85]">
        The page you are looking for may have moved or does not exist. Let us walk you back to where
        you need to be.
      </p>

      {/* CTAs */}
      <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pt-2">
        <Link to={ROUTES.HOME} className="btn-primary">
          <RiHome4Line size={17} />
          Back to Home
        </Link>
        <Link to={ROUTES.SERVICES} className="btn-outline">
          Explore Services
          <RiArrowRightLine size={17} />
        </Link>
      </div>
    </div>
  </section>
)
